<template>
    <v-flex xs12 sm8 offset-lg2>
        <v-card p5  style="padding-left: 15px;padding-right: 15px">
            <v-card-title>
                <div>
                    <span class="headline">Datos personales</span><br>
                    <span class="grey--text">Manten todos tus datos actualizados</span><br>
                </div>
            </v-card-title>
            <div>
                <sync-loader  :color="color"  v-if="spiner" style="margin-left: 45%; padding-top: 5%; padding-bottom: 5%"></sync-loader>
                <v-form @submit.prevent="updateDataPerson()" v-else>
                    <v-container>
                        <v-layout>
                            <v-flex  >
                                <v-text-field
                                        v-model="people_first_name"
                                        label="Nombres"
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-flex
                                    xs12
                                    md6 >
                                <v-text-field
                                        v-model="people_surnames"
                                        label="Apellidos"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-container>
                        <v-layout>
                            <v-flex xs12
                                    md6 >
                                <v-text-field
                                        v-model="people_document"
                                        label="Cédula"
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-flex
                                    xs12
                                    md6 >
                                <v-text-field
                                        v-model="userId.email"
                                        label="E-mail"
                                        required
                                        readonly
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-container>
                        <v-layout>
                            <v-flex xs12
                                    md6 >
                                <v-text-field
                                        v-model="people_phone"
                                        label="Teléfono"
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-flex
                                    xs12
                                    md6 >
                                <v-text-field class="text-uppercase"
                                        v-model="people_mobile"
                                        label="Móvil"
                                        required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions class="pb-5">
                        <v-btn type="submit"  class="light-blue accent-4" style="color: white">Actualizar</v-btn>
                    </v-card-actions>
                </v-form>
            </div>

        </v-card>
    </v-flex>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import SyncLoader from 'vue-spinner/src/PulseLoader.vue'
    export default {
        name: 'personalData',
        components: {
            SyncLoader
        },
        created(){
            this.getDataPerson()
        },
        data(){
            return {
                spiner:false,
                people_first_name:'',
                people_surnames:'',
                people_document:'',
                email:'',
                people_phone:'',
                people_mobile:'',
                people_birthday:'',
                sex:'',
                color: '#F4511E',
                size:''
            }
        },
        computed: {
            ...mapState,
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
        },
        methods:{
            getDataPerson: function () {
                var url = '/api/v1/setting/dataPerson';
                this.spiner = true;
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    email:this.userId.email
                }).then(response => {
                    this.person = response.data.person;
                    this.people_first_name = response.data.person.people_first_name;
                    this.people_surnames = response.data.person.people_surnames;
                    this.people_document = response.data.person.people_document;
                    this.people_phone = response.data.person.people_phone;
                    this.people_mobile = response.data.person.people_mobile;
                    this.people_birthday = response.data.person.people_birthday;
                    this.sex = response.data.person.sex;
                    this.spiner = false;
                });
            },
            updateDataPerson:function () {

                var url = '/api/v1/setting/update/UpdateDataPerson';
                this.spiner = true;
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    id:this.userId.id,
                    name     : this.people_first_name,
                    last_name: this.people_surnames,
                    document : this.people_document,
                    phone    : this.people_phone,
                    movil    : this.people_mobile,
                    birthday : this.people_first_name,
                    sex      : this.sex,
                }).then(response => {
                    console.log(response.data)

                    this.person = response.data.person;
                    this.spiner = false;
                });

            },

        }

    }
</script>